import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '@/config/routes.config';
import { useUserRoles } from '@/hooks/useUserRoles';

/** Employee management and reporting require an HR or administrator role. */
export function HRRoute() {
  const { isAdmin, isGlobalHR, isCountryHR } = useUserRoles();
  return isAdmin || isGlobalHR || isCountryHR
    ? <Outlet />
    : <Navigate to={ROUTES.DASHBOARD} replace />;
}
